<template>
  <div class="addCustomerCondition">
    <div class="title">
      <i class="el-icon-s-marketing" style="color: #006eff"></i>
      新增客户情况
    </div>
    <div style="margin-top: 10px">
      <timeGroupSelect @queryValue="queryCustomer"/>
    </div>
    <div id="addCustomerChart"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import timeGroupSelect from "@/views/index/comp/timeGroupSelect";
import DayJS from "dayjs";

export default {
  components: {
    timeGroupSelect
  },
  data() {
    return {
      option:{
        xAxis: {
          type: 'category',
          boundaryGap: false, // false时从0刻度开始
          data: []
        },
        yAxis: {
          type: 'value',
          splitLine:{
            show:true,
            lineStyle:{
              type:'dashed'
            }
          }
        },
        series: [
          {
            data: [],
            type: 'line',
            smooth: true,
            lineStyle: {
              color: '#006eff'
            },
            itemStyle: {
              color: '#006eff'
            },
            symbol: 'emptyCircle', // 几何圆
            symbolSize: 10,
            areaStyle: { // 区域填充样式
              color: { // 填充的颜色 // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#006eff', // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#ffffff' // 100% 处的颜色
                  }
                ],
                global: false, // 缺省为 false
              }
            }
          }
        ],
        grid: {
          left: '8%',
          right: '4%',
          top: '10%',
          // bottom: '15%',
        },
        tooltip: { // 鼠标悬浮提示框显示 X和Y 轴数据
          trigger: 'axis',
          axisPointer: {
            lineStyle: {
              type: 'dashed',
            }
          }
          // backgroundColor: 'rgba(32, 33, 36,.7)',
          // borderColor: 'rgba(32, 33, 36,0.20)',
          // borderWidth: 1,
          // textStyle: { // 文字提示样式
          //   color: '#fff',
          //   fontSize: '12'
          // },
          // axisPointer: { // 坐标轴虚线
          //   type: 'cross',
          //   label: {
          //     backgroundColor: '#6a7985'
          //   }
          // },
        }
      },
      myChart: '',
      curYear:DayJS().format("YYYY"),
      // 时间段
      val: '',
    }
  },
  mounted() {
    this.initECharts();
  },
  methods: {
    initECharts() {
      let chartDom = document.getElementById('addCustomerChart');
      this.myChart = echarts.init(chartDom);
      this.option && this.myChart.setOption(this.option);
    },
    queryCustomer(val) {
      this.val = val;
      const [startTime, endTime] = val;
      let url = `/Crm/Static/StaticCustomerMonth?startTime=${startTime}&endTime=${endTime}`;
      this.$axios.get(url).then((res) => {
        this.option.xAxis.data = res.map( (r,i,d) => {
          if(r.month>d[d.length-1].month) {
            return `${ this.curYear-1 }.${ r.month }`
          } else {
            return `${ this.curYear }.${ r.month }`
          }
        });
        this.option.series[0].data = res.map( r => r.count);
        this.initECharts();
      });
    }
  }
}
</script>

<style scoped lang="scss">
  .addCustomerCondition {
    display: flex;
    flex-direction: column;
    flex: 1;
    border: 1px solid #dfe0eb;
    border-radius: 12px;
    border-top: 3px solid #006eff;
    padding: 5px 15px;
    background: white;
    box-shadow: 0 2px 6px 0 rgba(218,218,253,65%), 0 2px 6px 0 rgba(206,206,238,54%);
    overflow: hidden;
    .title {
      font-weight: bold;
      font-size: 18px;
      margin-top: 10px;
    }

    #addCustomerChart {
      width: 100%;
      flex: 1;
    }
  }
</style>
